import { Link } from "@remix-run/react"
import { cva } from "class-variance-authority"
import { COMPANY_LINKS, SOCIAL_LINKS } from "../ui/links.ts"
import { SectionLayout } from "./ui/section-layout.tsx"

export const Footer = ({ className }: { className?: string }) => {
  return (
    <SectionLayout size="fluid" theme="dark" className={classForFooter({ className })}>
      <div className="flex flex-col md:flex-row md:gap-5">
        {SOCIAL_LINKS.map((link, id) => (
          <Link
            key={id}
            to={link.href}
            className={classNameForLink({
              className:
                "[&:not(:last-child)]:bshadow-b bshadow-gray-6 md:bshadow-transparent py-2 md:py-0",
            })}
            target="_blank"
            rel="noreferrer"
          >
            {link.text}
          </Link>
        ))}
      </div>
      <div className="flex items-center gap-5">
        {COMPANY_LINKS.map((link, id) => (
          <Link
            key={id}
            to={link.href}
            className={classNameForLink()}
            target="_blank"
            rel="noreferrer"
          >
            {link.text}
          </Link>
        ))}
      </div>
    </SectionLayout>
  )
}

const classForFooter = cva([
  "flex flex-col justify-between gap-24 md:gap-4 md:flex-row md:items-center p-4",
])

const classNameForLink = cva(["inline-block text-xs text-white hover:underline"])
